'use strict';

function titleizeCamelcase(str) {
  str = '' + str;
  str = str.replace(/([A-Z]+)/g, ' $1');
  var parts = str.split(' ');
  var out = [];

  for (var i = 0; i < parts.length; i++) {
    var part = parts[i];

    if (part.toUpperCase() === part) {
      out.push(part);
    } else {
      out.push(part.charAt(0).toUpperCase() + part.substr(1).toLowerCase());
    }
  }

  return out.join(' ');
}

function capitalize(s) {
  return s.replace(/(^\s*)(\S)(.*)$/g, function (match, whitespace, firstLetter, rest) {
    return whitespace + firstLetter.toUpperCase() + rest;
  });
}

function escapeHTML(unsafe) {
  return unsafe.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
} // Escapes meta characters (via MDN)


function escapeRegExp(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&'); // eslint-disable-line
} // Compute the edit distance between the two given strings
// http://en.wikibooks.org/wiki/Algorithm_Implementation/Strings/Levenshtein_distance#JavaScript


function editDistance(a, b) {
  if (a.length === 0) {
    return b.length;
  }

  if (b.length === 0) {
    return a.length;
  }

  var matrix = []; // increment along the first column of each row

  var i = 0;

  while (i <= b.length) {
    matrix[i] = [i];
    i++;
  } // increment each column in the first row


  var j = 0;

  while (j <= a.length) {
    matrix[0][j] = j;
    j++;
  } // Fill in the rest of the matrix


  i = 1;

  while (i <= b.length) {
    j = 1;

    while (j <= a.length) {
      if (b.charAt(i - 1) === a.charAt(j - 1)) {
        matrix[i][j] = matrix[i - 1][j - 1];
      } else {
        // substitution
        // insertion
        matrix[i][j] = Math.min(matrix[i - 1][j - 1] + 1, Math.min(matrix[i][j - 1] + 1, matrix[i - 1][j] + 1)); // deletion
      }

      j++;
    }

    i++;
  }

  return matrix[b.length][a.length];
} // This method will check if a string has Ascenders or Capitalized characters
// Ascender in typography are lower case characters that extend above the median line


var hasAscendersRegexp = /[^qweryuopasgzxcvnm]/;

function hasAscendersOrCaps(text) {
  return hasAscendersRegexp.test(text);
} // Descenders in typography is a portion of a letter that extends below the baseline font.
// In most fonts, descenders are reserved for lowercase characters such as g, j, q, p, y


var hasDescendersRegexp = /[gjqpy]/;

function hasDescenders(text) {
  return hasDescendersRegexp.test(text);
}

function linksToText(string) {
  return string.replace(/<a(?:.|\n)*?>|<\/a>/gm, '');
} // Replaces any non-alpha characters with underscores
// @param  {String} str


function sanitize(str) {
  return str.toString().replace(/[^A-Za-z0-9]/g, '_');
} // Test if the string only has ASCII characters


function isAsciiOnly(str) {
  for (var i = 0; i < str.length; i++) {
    if (str.charCodeAt(i) > 127) {
      return false;
    }
  }

  return true;
}

module.exports = {
  capitalize: capitalize,
  escapeHTML: escapeHTML,
  escapeRegExp: escapeRegExp,
  editDistance: editDistance,
  hasAscendersOrCaps: hasAscendersOrCaps,
  hasDescenders: hasDescenders,
  isAsciiOnly: isAsciiOnly,
  linksToText: linksToText,
  sanitize: sanitize,
  titleizeCamelcase: titleizeCamelcase
};